import cn from 'classnames';
import { AdminListRowCell } from '../AdminListRowCell';
import { StyledAdminGroupPoolConfigsListRow } from './styles';
import { IGroupPoolConfig } from 'types';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Button } from 'components/shared';
import { AdminConfirmModal } from '../AdminConfirmModal';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down-full.svg';

export interface IGroupPoolConfigsListRowProps {
  children?: React.ReactNode;
  config: IGroupPoolConfig;
  onChange: (updatedConfig: IGroupPoolConfig) => void;
  onDelete: (poolId: number) => Promise<void>;
  onChangeOrder: (id: number, priority: number) => void;
}

export const paymentFieldMap: Record<
  string,
  (payment: IGroupPoolConfigsListRowProps['config']) => React.ReactNode
> = {
  name: (config) => config.name,
  host: (config) => config.host,
  port: (config) => config.port,
  algorithm: (config) => config.algorithm,
  maxAttempts: (config) => config.maxAttempts,
  user: (config) => config.user,
  password: (config) => config.password,
};

export const AdminGroupPoolConfigsListRow = ({
  config,
  onChange,
  onChangeOrder,
  onDelete,
}: IGroupPoolConfigsListRowProps) => {
  const { t } = useTranslation();
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const closeConfirmModal = () => {
    setShowConfirmModal(false);
  };

  const submitDeletePoolConfigHandler = () => {
    setShowConfirmModal(true);
  };

  const submitDeletePoolConfigAction = async () => {
    onDelete(config.id);
    setShowConfirmModal(false);
  };

  const increasePriorityHandler = async () => {
    onChangeOrder(config.id, config.priority + 1);
  };

  const decreasePriorityHandler = async () => {
    if (config.priority > 0) {
      onChangeOrder(config.id, config.priority - 1);
    }
  };

  return (
    <StyledAdminGroupPoolConfigsListRow>
      <div className="admin-list-cell-container order">
        <AdminListRowCell>
          <div className="admin-list-cell-order-container">
            <div className="admin-list-cell-change-order-up" onClick={increasePriorityHandler}>
              <ArrowDownIcon />
            </div>
            <div className="admin-list-cell-change-order-down" onClick={decreasePriorityHandler}>
              <ArrowDownIcon />
            </div>
          </div>
        </AdminListRowCell>
      </div>

      <div className="admin-list-cell-container priority">
        <AdminListRowCell>{config.priority}</AdminListRowCell>
      </div>

      {Object.entries(paymentFieldMap).map(([title, valueGetter]) => (
        <div key={title} className={cn('admin-list-cell-container', title.toLowerCase())}>
          <AdminListRowCell>
            <input
              type="text"
              value={valueGetter(config) as string}
              onChange={(e) => onChange({ ...config, [title]: e.target.value })}
            />
          </AdminListRowCell>
        </div>
      ))}

      <div className="admin-list-cell-container actions">
        <AdminListRowCell>
          <Button
            title={t('adminPage.editPoolConfigs.delete')}
            onClick={submitDeletePoolConfigHandler}
          />
        </AdminListRowCell>
      </div>
      {showConfirmModal && (
        <AdminConfirmModal
          title={t('adminPage.confirmModal.deletePoolConfig')}
          onConfirm={submitDeletePoolConfigAction}
          onCancel={closeConfirmModal}
          show={showConfirmModal}
        />
      )}
    </StyledAdminGroupPoolConfigsListRow>
  );
};
